export const OfferingsPlatterWidgetFormFields: React.FunctionComponent<
  React.PropsWithChildren<unknown>
> = () => {
  return <></>;
};
